// store.js
import { ref } from 'vue';
import { defineStore } from 'pinia';

export const useMainStore = defineStore('main', () => {
    const message = ref();
    function setMessage(newMessage) {
        message.value = newMessage;
    }
    function clearMessage() {
        message.value = '';
    }

    return { message, setMessage, clearMessage };
});
